<template>
  <div>
  <el-dialog :visible.sync="this.$root.orderDetailDialog" width="90%" :before-close="handleClose" center title="Захиалгийн дэлгэрэнгүй">
    <el-row>
      <el-col>
        <div class="txtcenter text_black">
          <h2>{{ orderDetailProp.track_code }}</h2>
        </div><br>
      </el-col>
      <el-col>
        <p class="txtcenter">дээрх track кодтой  захиалга</p><br>
      </el-col>
      <div style="margin-left: 5px; margin-bottom: 10px;">
        <hr>
        <div>
          <span v-if="orderDetailProp.ConfigType">Ачааны төрөл - {{ orderDetailProp.ConfigType.name }}</span>
        </div>
        <div>
          <span v-if="orderDetailProp.price">Трак кодын үнэ: {{ orderDetailProp.price | formatCurrency() }}</span>
        </div>
        <div v-if="orderDetailProp.save_price && orderDetailProp.save_price != 0">
          <span v-if="orderDetailProp.price">Хадгалалтын төлбөр: {{ orderDetailProp.save_price | formatCurrency() }}</span>
        </div>
        <div>
          <span v-if="orderDetailProp.is_paid === 1" class="no_wrap">Төлбөр төлсөн эсэх: Тийм</span>
        </div>
        <div>
          <span v-if="orderDetailProp.is_paid === 0 || orderDetailProp.is_paid === null" class="no_wrap">Төлбөр төлсөн эсэх: Үгүй</span>
        </div>
      </div>
      <el-col v-for="item, index in orderDetailProp.Progress" :key="index">
        <el-card>
          <el-tag>{{ returnStatusValue(item.progress_code) }}</el-tag><br><br>
          <div>
            <span v-if="item.createdAt">Төлөвийн огноо: {{ item.createdAt.split('T')[0] }}</span>
          </div>
          <div>
            <span v-if="item.Branch" class="no_wrap">Ачаа буусан салбар: {{ item.Branch.branch_name }}</span>
          </div>
          <div>
            <span v-if="item.description" class="no_wrap">Тайлбар: {{ item.description }}</span>
          </div>
          <div>
            <span v-if="item.Address && item.progress_code === 130" class="no_wrap">Хүлээн авах хаяг: {{ item.Address.nick_name }} - {{ item.Address.detail_address }}</span>
          </div>
          <div>
            <template>
              <span v-if="item.start_date" class="no_wrap">Хадгалуулж эхлэх огноо: {{ item.start_date.split('T')[0] }}</span>
            </template>
          </div>
          <div>
            <span v-if="item.end_date" class="no_wrap">Хадгалуулж дуусах огноо: {{ item.end_date.split('T')[0] }}</span>
          </div>
          <el-card v-for="checkProgress,index in item.CheckTrackCode" :key="index" class="m-t-10">
            <el-tag v-if="checkProgress.type && checkProgress.type === 'new'" size="mini" type="primary">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <el-tag v-if="checkProgress.type && checkProgress.type === 'to_ereen'" size="mini" type="warning">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <el-tag v-if="checkProgress.type && checkProgress.type === 'to_mongol'" size="mini" type="info">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <el-tag v-if="checkProgress.type && checkProgress.type === 'to_user'" size="mini" type="danger">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <el-tag v-if="checkProgress.type && checkProgress.type === 'from_user'" size="mini" type="primary">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <el-tag v-if="checkProgress.type && checkProgress.type === 'cancel'" size="mini" type="danger">{{ returnCheckTrackCodeStatusValue(checkProgress.type) }}</el-tag>
            <div v-if="checkProgress.createdAt" class="no_wrap">Үүсгэсэн огноо: <span class="check_tarck_img_text">{{ checkProgress.createdAt.split('T')[0] }}</span></div>
            <div v-if="checkProgress.hurgelt && checkProgress.hurgelt === true" class="no_wrap">Хүлээн авах хэлбэр: <span class="check_tarck_img_text">Хүргэлтээр авна</span></div>
            <div v-if="checkProgress.ochij_avah && checkProgress.ochij_avah === true" class="no_wrap">Хүлээн авах хэлбэр: <span class="check_tarck_img_text">Очиж авна</span></div>
            <div v-if="checkProgress.map_to_ereen && checkProgress.map_to_ereen === true" class="no_wrap">Газрын зураг дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очсон</span></div>
            <div v-if="checkProgress.map_to_ereen && checkProgress.map_to_ereen === false" class="no_wrap">Газрын зураг дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очоогүй</span></div>
            <div v-if="checkProgress.map_to_ereen_aguulah && checkProgress.map_to_ereen_aguulah === true" class="no_wrap">Систем дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очсон</span></div>
            <div v-if="checkProgress.map_to_ereen_aguulah && checkProgress.map_to_ereen_aguulah === false" class="no_wrap">Систем дээр эрээнд очсон эсэх: <span class="check_tarck_img_text">Очоогүй</span></div>
            <div v-if="checkProgress.map_to_ereen_date" class="no_wrap">Газрын зураг дээр эрээнд очсон огноо: <span class="check_tarck_img_text">{{ checkProgress.map_to_ereen_date.split('T')[0] }}</span></div>
            <div v-if="checkProgress.fb_name" class="no_wrap">Facebook нэр: <span class="check_tarck_img_text">{{ checkProgress.fb_name }}</span></div>
            <div v-if="checkProgress.description" class="no_wrap">Тайлбар: <span class="check_tarck_img_text">{{ checkProgress.description }}</span></div>
            <div v-if="item.CheckedBranch && item.CheckedBranch.branch_name" class="no_wrap">Захиалсан салбар: <span class="check_tarck_img_text">{{ item.CheckedBranch.branch_name }}</span></div>
            <div v-for="itemImg, index in checkProgress.CheckImage" :key="index" class="m-t-10">
              <el-image :src="'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + itemImg.img_path" :preview-src-list="['https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + itemImg.img_path]" fit="fill" style="width: 100%; border-radius: 8px; margin-bottom: 10px; border: 1px black solid;" />
              <hr class="m-t-5 m-b-15">
            </div>
          </el-card>
        </el-card><br>
      </el-col>
      <hr>
      <!-- hvrgelt -->
      <div v-if="showDelivery">
        <el-col>
          <template>
            <hr>
            <u>Та хүргэлтээр авах огноо болон цагаа сонгоно уу!</u><br><br>
            <div class="m-b-20">
              <el-date-picker v-model="hvrgvvleh_ognoo" type="datetime" placeholder="Огноо, цаг оруулах"></el-date-picker>
            </div>
            <u>Хүлээн авах хаягаа сонгоно уу!</u><br><br>
            <el-radio-group class="vertical-radio-group" v-model="address_id">
                <el-radio-button v-for="item, index in addressList" :key="index" :label="item.id" :value="item.id" style="margin: 5px;" class="selected-address">
                  {{ item.nick_name }} - {{ item.detail_address }}
                </el-radio-button>
            </el-radio-group>
          </template>
        </el-col>
        <el-col>
          <hr>
          <!-- buhiin urguu - hvrgelt -->
          <el-card class="m-b-10" v-if="buhiinUrguuAmount !== null && deliveryPriceNiitBuhiinUrguu !== null">
            <div class="m-b-10">
              <el-tag>Бөхийн өргөө</el-tag>
            </div>
            <div class="m-b-10">
              <span v-if="deliveryPriceNiitBuhiinUrguu">Хүргэлтийн үнэ : {{ deliveryPriceNiitBuhiinUrguu | formatCurrency() }}</span>
            </div>
            <div class="m-b-10">
              <b>Хөнгөлөлтийн үнэ: </b>
            </div>
            <div class="m-b-10">
              <b>Нийт төлөх үнэ : {{ buhiinUrguuAmount + deliveryPriceNiitBuhiinUrguu | formatCurrency() }}</b>
            </div>
            <span class="font_size_10">
              <div>Банк : Хаан банк</div>
              <div>Дансны дугаар : MN 89000500 5402587325
                <el-button @click="copyToClipboardDans('MN 89000500 5402587325')"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
              </div>
              <div>Дансны эзэмшигч : Ж. Саруултуяа</div>
              <div>Гүйлгээний утга : {{ phone_number }}
                <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
              </div>
            </span>
            <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
          </el-card>
          <!-- buhiin urguu - hvrgelt -->
          <el-card class="m-b-10" v-if="officerAmount !== null && deliveryPriceNiitOfficer !== null">
            <div class="m-b-10">
              <el-tag>Оффицер</el-tag>
            </div>
            <div class="m-b-10">
              <span v-if="deliveryPriceNiitOfficer">Хүргэлтийн үнэ : {{ deliveryPriceNiitOfficer | formatCurrency() }}</span>
            </div>
            <div class="m-b-10">
              <b>Нийт төлөх үнэ : {{ officerAmount + deliveryPriceNiitOfficer | formatCurrency() }}</b>
            </div>
            <span class="font_size_10">
              <div>Банк : Хаан банк</div>
              <div>Дансны дугаар : MN890005005402587325
                <el-button @click="copyToClipboardDans('MN890005005402587325')"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
              </div>
              <div>Дансны эзэмшигч : Ж. Саруултуяа</div>
              <div>Гүйлгээний утга : {{ phone_number }}
                <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
              </div>
            </span>
            <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
          </el-card>
          <hr>
        </el-col>
      </div>
      <el-col>
        <el-button class="w-100" type="primary" @click="openSendRefply()">Хариу илгээх</el-button>
      </el-col>
      <el-col :span="24" v-if="showDeposit || showDelivery" class="m-t-20">
        <el-button type="success" @click="createProgress('showDelivery')" class="w-100" size="small"> Хадгалах </el-button>
        <div class="m-t-10 m-b-10" v-if="showDelivery">
          <el-button type="primary" @click="addAddressDialog()" class="w-100" size="small"> Хаяг нэмэх </el-button>
        </div>
        <hr>
      </el-col>
      <!-- hadgaaluulah -->
      <el-col v-if="showDeposit">
          <div class="m-l-3 m-r-3 m-b-10">
            <i class="no-wrap color-red">Таны ачааг Монголд ирсэнээс хойш 21 хоног үнэгүй хадгалах боломжтой ба 21-с дээш хоног болсон тохиолдолд тухайн барааны тээврийн үнийн дүнгийн 10 хувиар хоног тутамд алданги тооцох болохыг мэдэгдэж байна.</i>
          </div>
        <div class="block">
          <span class="demonstration">Эхлэх огноо: </span>
          <el-date-picker v-model="startDate" type="date" placeholder="Сонгоно уу"></el-date-picker>
        </div><br>
        <div class="block">
          <span class="demonstration">Дуусах огноо: </span>
          <el-date-picker v-model="endDate" type="date" placeholder="Сонгоно уу"></el-date-picker>
        </div><br>
        <el-button type="success" @click="createProgress('showDeposit')">
          Хадгалах
        </el-button><br><br>
      </el-col>
      <!-- ochij avah -->
      <el-col v-if="showGoToGet">
        <div class="block">
          <span class="demonstration">Очиж авах огноо, цаг: </span><br><br>
          <el-date-picker v-model="ochij_avah_ognoo" type="datetime" placeholder="Сонгоно уу"></el-date-picker>
        </div><br>
        <el-card class="m-b-10" v-if="orderDetailProp.irsen_salbar === 1">
          <div class="m-b-10">
            <b>Нийт үнэ : {{ orderDetailProp.price | formatCurrency() }}</b>
          </div>
          <span class="font_size_10">
            <div>Банк : Хаан банк</div>
            <div>Дансны дугаар : 5039930627
              <el-button @click="copyToClipboardDans(5039930627)"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
            <div>Дансны эзэмшигч : Ж. Саруултуяа</div>
            <div>Гүйлгээний утга : {{ phone_number }}
              <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
          </span>
          <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
        </el-card>
        <el-card class="m-b-10" v-if="orderDetailProp.irsen_salbar === 2">
          <div class="m-b-10">
            <b>Нийт үнэ : {{ orderDetailProp.price | formatCurrency() }}</b>
          </div>
          <span class="font_size_10">
            <div>Банк : Хаан банк</div>
              <div>Дансны дугаар : MN 86000500 5300542312
              <el-button @click="copyToClipboardDans('MN 86000500 5300542312')"  class="font_size_10" type="text" :style="{ color: isCopiedDans ? 'green' : 'black' }" :icon="isCopiedDans === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
            <div>Дансны эзэмшигч : Төмөр-Очир</div>
            <div>Гүйлгээний утга : {{ phone_number }}
              <el-button @click="copyToClipboard(phone_number)"  class="font_size_10" type="text" :style="{ color: isCopied ? 'green' : 'black' }" :icon="isCopied === true ? 'el-icon-check' : 'el-icon-copy-document'" circle></el-button>
            </div>
          </span>
          <p class="no-wrap font_size_10 color-red" style="text-align: center;">Та төлбөрөө төлсөн тохиолдолд салбараас таны ачааг бэлдэж хүргэлтэнд гаргана.</p>
        </el-card><br>
        <el-button type="success" @click="createProgress('showGoToGet')">
          Хадгалах
        </el-button><br><br>
      </el-col>
      <el-col>
        <el-button :disabled="isShow" class="text_color_white w-100" style="background-color: #007AFF; margin-bottom: 3px;" @click="showDelivery = showDeliveryButton()" width="100%">Хүргэлтээр авах</el-button>
        <div><el-button :disabled="isShow" class="text_color_white w-100" style="background-color: #555555; margin-bottom: 3px;" @click="showGoToGet = showGoToGetButton()" width="50px">Очиж авна</el-button></div>
        <div><el-button :disabled="isShow" class="text_color_white w-100" style="background-color: #EB9F24; margin-bottom: 3px;" @click="showDeposit = showDepositButton()" width="50px">Хадгалуулах</el-button></div>
      </el-col>
    </el-row>
  </el-dialog>
  <div>
    <AddressAddDialog v-if="this.$root.addressAddDialog"/>
  </div>
      <div>
        <el-dialog :visible.sync="this.sendReply" width="90%" :before-close="handleCloseReply" center title="Хариу илгээх">
          <el-input v-model="description" type="textarea" placeholder="Тайлбар оруулна уу" class="m-b-30"></el-input>
          <el-col :span="6" v-for="(img, index) in img_path" :key="index">
            <img :src="'https://daagiigaadskycargo.s3.ap-southeast-1.amazonaws.com' + img" style="width: 100%; border-radius: 8px; margin-bottom: 10px; border: 1px solid black;" />
          </el-col>
          <el-button class="w-100">
            <DynamicUploadImage @uploaded="handleImageUploaded"></DynamicUploadImage>
          </el-button>
          <div class="m-t-30">
            <el-button type="success" class="w-100" @click="handleSubmit">Илгээх</el-button>
          </div>
        </el-dialog>
      </div>
  </div>
</template>

<script>
import services from '@/helpers/services'
import AddressAddDialog from './addressAddDialog.vue'
import DynamicUploadImage from '@/components/dynamicUploadImage.vue'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'OrderDetailDialog',
  props: {
    orderDetailProp: Object,
    cuponPrice: Number
  },
  components: {
    AddressAddDialog,
    DynamicUploadImage
  },
  data () {
    return {
      track_code_detail: {
        Progress: []
      },
      customStatus: {},
      showDelivery: false,
      showDeposit: false,
      showGoToGet: false,
      goToGet: false,
      addressList: [],
      clickedAddress: {},
      address_id: null,
      isDisabled: true,
      startDate: null,
      endDate: '',
      orderType: null,
      ochij_avah_ognoo: null,
      isCopied: false,
      isCopiedDans: false,
      hvrgvvleh_ognoo: null,
      phone_number: null,
      deliveryPriceNiitBuhiinUrguu: 0,
      deliveryPriceNiitOfficer: 0,
      buhiinUrguuAmount: null,
      officerAmount: null,
      selectedTrackCodes: [this.orderDetailProp.track_code],
      sendReply: false,
      description: null,
      img_path: [],
      type: 'from_user'
    }
  },
  computed: {
    ...mapGetters([
      'userDetailGetter'
    ]),
    ...mapState({
      dynamic_img_url: state => state.dynamic_img_url
    })
  },
  created () {
    this.isShowButton()
  },
  watch: {
    '$root.addressAddDialog': function (newVal) {
      if (!newVal) {
        this.viewAddress()
      }
    },
    dynamic_img_url () {
      this.img_path = this.dynamic_img_url
    }
  },
  methods: {
    handleImageUploaded (imageUrl) {
      if (!Array.isArray(this.img_path)) {
        this.img_path = []
      }
      this.img_path.push(imageUrl)
    },
    isShowButton () {
      this.isShow = true
      this.orderDetailProp.Progress.forEach(element => {
        if (element.progress_code === 130 || element.progress_code === 140 || element.progress_code === 150) {
          this.isShow = true
        } else if (element.progress_code === 120 || element.progress_code === 170) {
          this.isShow = false
        } else {
          this.isShow = true
        }
      })
    },
    addAddressDialog () {
      this.$root.addressAddDialog = true
    },
    returnStatusValue (data) {
      const result = this.$root.statusArray.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    returnCheckTrackCodeStatusValue (data) {
      const result = this.$root.checkTrackCodeStatus.find(element => element.value === data)
      if (result) {
        return result.label
      } else {
        return 'empty'
      }
    },
    handleClose () {
      this.$root.orderDetailDialog = false
    },
    addressDetaiView (data) {
      this.clickedAddress = data
      this.$root.addressAddDialog = true
    },
    buttonDisable () {
      this.isDisabled = !this.isDisabled
    },
    async ochijAvahPrice () {
      try {
        this.phone_number = this.userDetailGetter.phone1
        const response = await services.getOchijAvahPrice(this.selectedTrackCodes)
        if (response.type === 'success') {
          this.delivery = response.data
          this.buhiinUrguuAmount = response.buhiinUrguu
          this.officerAmount = response.officer
        }
      } catch (error) {
        console.log(error)
      }
    },
    async deliveryPrice () {
      try {
        this.phone_number = this.userDetailGetter.phone1
        const response = await services.deliveryPrice(this.selectedTrackCodes)
        if (response.type === 'success') {
          if (response.deliveryPriceJinBuhiinUrguu && response.deliveryPriceVBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceJinBuhiinUrguu + response.deliveryPriceVBuhiinUrguu
          }
          if (response.deliveryPriceJinBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceJinBuhiinUrguu
          }
          if (response.deliveryPriceVBuhiinUrguu) {
            this.deliveryPriceNiitBuhiinUrguu = response.deliveryPriceVBuhiinUrguu
          }
          if (response.deliveryPriceJinOfficer && response.deliveryPriceVOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceJinOfficer + response.deliveryPriceVOfficer
          }
          if (response.deliveryPriceJinOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceJinOfficer
          }
          if (response.deliveryPriceVOfficer) {
            this.deliveryPriceNiitOfficer = response.deliveryPriceVOfficer
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    createProgress (data) {
      if (!this.address_id && data === 'showDelivery') {
        this.$alert('Хаяг сонгоогүй байна!', 'Анхааруулга', {
          confirmButtonText: 'Ойлголоо',
          type: 'warning'
        })
        return
      } else if (!this.hvrgvvleh_ognoo && data === 'showDelivery') {
        this.$alert('Та хүргүүлэх огноо болон цагаа оруулна уу!', 'Анхааруулга', {
          confirmButtonText: 'Ойлголоо',
          type: 'warning'
        })
        return
      } else if (!this.ochij_avah_ognoo && data === 'showGoToGet') {
        this.$alert('Та очиж авах огноо болон цагаа оруулна уу!', 'Анхааруулга', {
          confirmButtonText: 'Ойлголоо',
          type: 'warning'
        })
        return
      }
      if (data === 'showDelivery') {
        this.orderType = 130
      } else if (data === 'showGoToGet') {
        this.orderType = 140
      } else if (data === 'showDeposit') {
        this.orderType = 150
      }
      this.$root.fullscreenLoading = true
      services.createProgress(this.orderType, this.orderDetailProp.id, this.address_id, this.startDate, this.endDate, this.hvrgvvleh_ognoo, this.ochij_avah_ognoo)
        .then((response) => {
          this.$root.fullscreenLoading = false
          this.$alert('Таны захиалгийн төлөв амжилттай өөрчлөгдлөө. ', 'Амжилттай', {
            confirmButtonText: 'Ойлголоо',
            callback: action => {
              location.reload()
            }
          })
          this.$root.orderDetailDialog = true
        })
        .catch((error) => {
          this.$alert('Шинэчлэхэд алдаа гарлаа: ' + error, 'Алдаа', {
            confirmButtonText: 'Ойлголоо'
          })
        })
    },
    showDeliveryButton () {
      this.showDeposit = false
      this.showGoToGet = false
      this.viewAddress()
      this.ochijAvahPrice()
      this.deliveryPrice()
      return true
    },
    showGoToGetButton () {
      this.showDelivery = false
      this.showDeposit = false
      this.phone_number = this.userDetailGetter.phone1
      return true
    },
    showDepositButton () {
      this.showDelivery = false
      this.showGoToGet = false
      return true
    },
    goToGetButton () {
      this.showDeposit = false
      this.showDelivery = false
      return true
    },
    async viewAddress () {
      this.$root.fullscreenLoading = true
      const userId = this.userDetailGetter.id
      this.phone_number = this.userDetailGetter.phone1
      const response = await services.viewAddress(userId)
      if (response.type === 'success') {
        this.addressList = response.data
        this.$root.fullscreenLoading = false
      }
    },
    async copyToClipboard (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopied = true
        setTimeout(() => {
          this.isCopied = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    async copyToClipboardDans (text) {
      try {
        await navigator.clipboard.writeText(text) // Текстийг хуулна
        this.isCopiedDans = true
        setTimeout(() => {
          this.isCopiedDans = false
        }, 1000)
      } catch (err) {
        console.error('Failed to copy text: ', err)
      }
    },
    isShowCheckButton () {
      const progresses = this.orderDetailProp.Progress
      if (!Array.isArray(progresses) || progresses.length === 0) return false

      // created_at-ийг огнооны талбараар нь солиорой!
      const sorted = progresses.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      const lastProgress = sorted[sorted.length - 1]

      const type = lastProgress.CheckTrackCode.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
      const lastestType = type[type.length - 1]
      return lastestType?.type === 'to_user'
    },
    openSendRefply () {
      this.sendReply = true
    },
    handleSubmit () {
      try {
        if (!this.description) {
          return this.$notify({
            title: 'Амжилтгүй',
            message: 'Тайлбар оруулна уу',
            type: 'warning',
            duration: 3000
          })
        }
        this.$root.fullscreenLoading = true
        const payload = {
          progress_id: this.orderDetailProp.id,
          description: this.description,
          img_path: this.img_path,
          type: this.type,
          is_change: 'change'
        }
        const response = services.createCheckTrackCode(payload)
        if (response) {
          this.$root.fullscreenLoading = false
          this.$notify({
            title: 'Амжилттай',
            message: 'Амжилттай',
            type: 'success',
            duration: 3000
          })
          this.handleCloseReply()
          // location.reload()
          this.$root.fullscreenLoading = false
        }
      } catch (error) {
        this.$root.fullscreenLoading = false
        alert(
          (this.$root.errorMessage =
            error.message || 'Өгөгдөл татхад алдаа гарлаа.')
        )
      }
    },
    handleCloseReply () {
      this.sendReply = false
    }
  }
}
</script>

<style>
  .icon_border{
  width: 20px;
  height: 20px;
  background-color: #409eff;
  color: white;
  border-radius: 5px;
  }
  .text-grey{
    color: grey;
    font-size: 13px;
  }
  .no_wrap{
    word-break: keep-all;
    white-space: normal;
    overflow-wrap: break-word;
  }
  .selected-address {
    background-color: rgba(37 57 112 / 1);
    color: white;
    border-radius: 5px;
  }
  .vertical-radio-group {
  display: flex;
  flex-direction: column; /* Доошоо цувуулах */
  gap: 10px; /* Элементүүдийн хоорондын зай */
}
</style>
